// extracted by mini-css-extract-plugin
export default {"title":"xeN3Y","titleIcon":"luh0C"};